import * as React from "react";
import { Link, useParams } from "react-router-dom";
import {
  ContentLayout,
  CustomeDialog,
  CustomTable,
  HeaderBreadcrumbs,
} from "../../../shared";
import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useSettingsFeeHistory } from "../hooks/useSettingsFeeHistory";

export const SettingsFeeHistory = () => {
  const { state, handleModal } = useSettingsFeeHistory();

  const { dataList, isLoading, selectedData, isModalOpen, selectedDetails } =
    state;

  const ActionButtons = ({ data }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <Button
          variant="outlined"
          sx={{ border: "none", ":hover": { border: "none" } }}
          size="small"
          onClick={() => handleModal(true, data)}
        >
          View Changes
        </Button>
      </div>
    );
  };
  console.log(selectedData);

  const column = React.useMemo(
    () => [
      {
        Header: "Date & Time",
        accessor: "done_on",
      },
      {
        Header: "User",
        accessor: (row) => (row.done_by_name ? row.done_by_name : "System"),
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        accessor: (row, index) => {
          return <ActionButtons data={row} />;
        },
      },
    ],
    []
  );

  const ChangesTable = () => {
    return (
      <>
        <Stack padding="12px">
          <Stack>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Keys</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>New Value</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Old Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedData && selectedData.length > 0 ? (
                  selectedData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.keys}</TableCell>
                      <TableCell>{item.new}</TableCell>
                      <TableCell>{item.old}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3}>No changes found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Stack>
        </Stack>
      </>
    );
  };

  const breadcrumbs = [
    { name: "Dashboard", href: "/" },
    { name: "Settings", href: "/settings" },
    { name: "History" },
  ];

  return (
    <>
      <ContentLayout
        title="History"
        breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      >
        <CustomTable
          columns={column}
          data={dataList}
          isLoading={isLoading}
          tableTitle="History"
          defaultSearch={false}
          searchBar={false}
        />
      </ContentLayout>

      <CustomeDialog
        title={
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: "400",
              padding: "10px 20px",
            }}
          >
            Changes done by{" "}
            <span style={{ color: "#1976d2" }}>
              {selectedDetails?.done_by_name}
            </span>{" "}
            on{" "}
            <span style={{ color: "#1976d2" }}>{selectedDetails?.done_on}</span>
          </Typography>
        }
        PaperProps={{
          sx: {
            minWidth: "579px",
            minHeight: "297px",
          },
        }}
        open={isModalOpen}
        handleClose={() => handleModal(false)}
        content={<ChangesTable />}
      />
    </>
  );
};
